<router-outlet></router-outlet>
<ng-container *ngIf="lockScreen">
<div class="lock-screen">
</div>
<span class="spinner">
    <mat-spinner></mat-spinner>
</span>
</ng-container>


